import styled from '@benzinga/themetron';
import React, { ReactNode } from 'react';
import { ThemeColors } from './themecolor';

interface PreferencesModeBtnProps {
  title: string;
  selected: string;
  value: string;
  icon?: ReactNode;
  blindIcon?: ReactNode;
  colors?: string[];
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const PreferencesModeBtn: React.FC<PreferencesModeBtnProps> = props => {
  return (
    <BtnWrapper icon={props.icon} onClick={props.onClick} selected={props.selected} value={props.value}>
      <IconWrapper selected={props.selected} value={props.value}>
        {props.icon}
      </IconWrapper>
      <ThemeTextWrapper>{props.title}</ThemeTextWrapper>
      {props.colors && <ThemeColors colors={props.colors} />}
      {props.blindIcon}
    </BtnWrapper>
  );
};

const BtnWrapper = styled.button<{ selected: string; icon: ReactNode }>`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  background: ${props =>
    props.value === props.selected ? props.theme.colors.backgroundInactive : props.theme.colors.backgroundActive};
  padding: ${props => (props.icon ? '1em' : '0.65em 1em')};

  text-align: left;
  color: ${props =>
    props.value === props.selected ? props.theme.colors.foregroundActive : props.theme.colors.foregroundInactive};

  svg path#antique-border,
  svg path#moon-border,
  svg path#sun-border,
  svg path#contrast-border,
  svg circle#contrast-border,
  svg path#contrast-half-filled {
    stroke: ${props =>
      props.value === props.selected ? props.theme.colors.foregroundActive : props.theme.colors.foregroundInactive};
  }

  &:hover {
    background: ${props => props.theme.colors.backgroundInactive};
    color: ${props => props.theme.colors.foregroundActive};

    svg path#antique-border,
    svg path#moon-border,
    svg path#sun-border,
    svg path#contrast-border,
    svg circle#contrast-border,
    svg path#contrast-half-filled {
      stroke: ${props => props.theme.colors.foregroundActive};
    }
  }

  &:focus {
    border: none;
    outline: none;
  }
`;

const IconWrapper = styled.div<{ selected: string; value: string }>``;

const ThemeTextWrapper = styled.div`
  flex-grow: 1;
  font-family: 'Nimbus Sans D OT', Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 20px;
  margin-bottom: -3px;
  margin-top: -5px;
  position: relative;
  width: fit-content;
`;
